import React from "react";
import { Reveal, Stagger, staggerItem } from "./motion/Reveal";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

/**
 * Testimonios REALES de la comunidad (facilitados por el cliente), verbatim.
 * No se inventan nombres — atribución respetuosa "Miembro de la comunidad".
 */
const TESTIMONIALS = [
    {
        text: "Alquimia del Alma es para mí una fuente casi diaria de consciencia, de guía, de nueva visión, que me hace conectar conmigo misma desde una mirada abierta a reconocer que somos cuerpo, mente y espíritu. Me apoyo en Alquimia del Alma para crecer un poquito cada día. Sus tips, lecturas, consejos, meditaciones… son una maravilla sanadora.",
    },
    {
        text: "Para mí Alquimia del Alma es una elevación de vibración que me ayuda en mi día a día, al igual que las meditaciones y los ejercicios muy concretos para conocerme, conocer mis emociones y saber gestionarlas. Es un apoyo y me siento sostenida.",
    },
    {
        text: "Cuando era más joven no entendía por qué estaba por aquí. Buscaba unas almas que vibrasen con la mía y no las encontraba; me sentía sola, excluida. Desde que conocí a Lidia mi vida cambió, porque sentí pertenecer a una familia del alma junto a ella y junto a Santi. Los meses que llevamos en Alquimia del Alma me hacen sentir afortunada por pertenecer a mi familia de almas. Es volver a casa, a la esencia. Gracias, gracias, gracias.",
    },
];

export default function Testimonials() {
    return (
        <section className="relative py-20 sm:py-28 bg-alma-white">
            <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
                <Reveal>
                    <div className="text-center max-w-2xl mx-auto mb-12">
                        <span className="text-xs tracking-[0.35em] uppercase text-alma-goldDeep font-medium">
                            Voces de la familia
                        </span>
                        <h2 className="mt-5 font-serif text-4xl sm:text-5xl leading-[1.05] text-alma-ink">
                            Lo que se siente
                            <span className="italic text-alma-goldDeep"> al pertenecer.</span>
                        </h2>
                    </div>
                </Reveal>

                <Stagger className="grid md:grid-cols-3 gap-6 items-start">
                    {TESTIMONIALS.map((t, i) => (
                        <motion.article
                            key={i}
                            variants={staggerItem}
                            data-testid={`testimonial-${i}`}
                            className="bg-alma-ivory border border-alma-mist rounded-3xl p-8 flex flex-col"
                        >
                            <Quote className="h-6 w-6 text-alma-gold/70 mb-4" strokeWidth={1.3} />
                            <p className="font-sans text-[15px] text-alma-slate leading-relaxed flex-1">
                                {t.text}
                            </p>
                            <div className="mt-6 flex items-center gap-2 text-alma-gold" aria-hidden>
                                {[...Array(5)].map((_, s) => (
                                    <span key={s} className="text-sm">✦</span>
                                ))}
                                <span className="ml-2 text-sm text-alma-slate/80">Miembro de la comunidad</span>
                            </div>
                        </motion.article>
                    ))}
                </Stagger>
            </div>
        </section>
    );
}
